import { useTranslation } from 'react-i18next';
import {
  Alert,
  AlertDescription,
  AlertTitle,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@shared/ui';

export function AlertShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.feedback.alert.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.feedback.alert.description')}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-3">
        <Alert>
          <AlertTitle>{t('uiLibrary.feedback.alert.defaultTitle')}</AlertTitle>
          <AlertDescription>{t('uiLibrary.feedback.alert.defaultDescription')}</AlertDescription>
        </Alert>
        <Alert variant="destructive">
          <AlertTitle>{t('uiLibrary.feedback.alert.destructiveTitle')}</AlertTitle>
          <AlertDescription>
            {t('uiLibrary.feedback.alert.destructiveDescription')}
          </AlertDescription>
        </Alert>
      </CardContent>
    </Card>
  );
}
